import { FC, memo } from 'react';
import { Body3, ListTextIconCol } from '@csp/csp-web-ui';
import { ZonedDateTimeDisplay } from '@csp/csp-common-model';
import { BioSampleBaseCol } from '../model/BioSampleBaseCol';
import { ValueDisplay } from '../model/ValueDisplay';

type Props = BioSampleBaseCol & {
  sampleStatusDateTime: ZonedDateTimeDisplay;
  sampleStatus: string;
  sampleStatusLabel: string;
  shippingNumber?: ValueDisplay;
};

export const SampleStatusCol: FC<Props> = memo(
  ({ sampleStatusDateTime, sampleStatus, sampleStatusLabel, shippingNumber, subLabelProps, children, ...props }) => (
    <ListTextIconCol
      title={sampleStatusLabel}
      text={sampleStatus}
      subLabelProps={{
        ...subLabelProps,
        text: sampleStatusDateTime.isSet ? sampleStatusDateTime.dateTime : undefined,
      }}
      {...props}
    >
      {shippingNumber?.isSet && (
        <Body3 color="textSecondary" noWrap>
          {shippingNumber.valueOrEditablePlaceholder}
        </Body3>
      )}
      {children}
    </ListTextIconCol>
  ),
);

SampleStatusCol.displayName = 'SampleStatusCol';
